// extracted by mini-css-extract-plugin
module.exports = {"button":"save-button_button___jRJJ","loading":"save-button_loading__MizLh"};